import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FinancialAlertsService} from '../../service/financial-alerts.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-confirmation-dialog-delete-alert',
    templateUrl: './confirmation-dialog-delete-alert.component.html',
    standalone: false
})
export class ConfirmationDialogDeleteAlertComnponent {
    isLoading = false;
    constructor(
        @Optional() public confirmationDialogRef: MatDialogRef<ConfirmationDialogDeleteAlertComnponent>,
        @Inject(MAT_DIALOG_DATA) public alertData: { workflowId:number, alertName:string, },
        private financialAlertsService: FinancialAlertsService,
        private _snackBar: MatSnackBar,
    ){}

    okClick(){
        if(this.alertData.workflowId) {
            this.isLoading = true;
            this.financialAlertsService.deleteAlert(this.alertData.workflowId).subscribe(()=>{
                this._snackBar.open('Alert deleted successfully', 'Dismiss', {
                    horizontalPosition: 'center',
                    verticalPosition: 'bottom',
                });
                this.confirmationDialogRef.close(true);
            });
        } else {
            this.confirmationDialogRef.close();
        }
    }

    onNoClick(){
        this.confirmationDialogRef.close(false);
    }
}